import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Services from './pages/Services';
import MentalHealthEducation from './pages/MentalHealthEducation';
import About from './pages/About';
import Resources from './pages/Resources';
import FAQs from './pages/FAQs';
import CrisisResources from './pages/CrisisResources';
import Contact from './pages/Contact';
import MedicalDisclaimer from './pages/MedicalDisclaimer';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import BookAppointment from './pages/BookAppointment';
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/mental-health-education" element={<MentalHealthEducation />} />
          <Route path="/about" element={<About />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/crisis-resources" element={<CrisisResources />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/book-appointment" element={<BookAppointment />} />
          <Route path="/medical-disclaimer" element={<MedicalDisclaimer />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;